/**
 * Field order utilities for sequential validation
 * Similar to buildFocusedFieldMap in organiser.utils.ts
 */

export interface TravellerData {
  encryptedId: string;
}

/**
 * Builds a map of fields where each field includes all previous fields in the sequence
 * Used for sequential validation - when a field is focused, all previous fields should show warnings if empty
 *
 * @param travellers - Array of traveller data with encryptedIds
 * @returns Map where each field key maps to an array of all fields up to and including itself
 */
export function buildRequiredInfoFieldMap(
  travellers: TravellerData[]
): Record<string, string[]> {
  const organiserFields = [
    "organiser-addressLine1",
    "organiser-addressLine2",
    "organiser-city",
    "organiser-postalCode",
    "organiser-identificationType",
    "organiser-identificationNumber",
  ];

  const travellerFields: string[] = [];
  travellers.forEach((traveller) => {
    travellerFields.push(
      `traveller-${traveller.encryptedId}-identificationType`
    );
    travellerFields.push(
      `traveller-${traveller.encryptedId}-identificationNumber`
    );
  });

  const allFields = [...organiserFields, ...travellerFields];

  const fieldMap: Record<string, string[]> = {};
  allFields.forEach((field, index) => {
    fieldMap[field] = allFields.slice(0, index + 1);
  });

  return fieldMap;
}
